import heroData from '@/data/hero.json';
import type { HeroSection } from '@/data/types';

export function useHeroData() {
  return {
    heroData: heroData as HeroSection
  };
}